module.exports = __webpack_public_path__ + "img/luca-awards-2021--client-app-of-the-year.77f31767.png";